"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmissionValueProvider = void 0;
var _source = require("../source");
var _state = require("../state");
var _data = require("../data");
var _LiteralSourceProvider = require("../source/LiteralSourceProvider");
const sourceProviders = new _source.SourceProviders().addSourceType(new _LiteralSourceProvider.LiteralSourceProvider()).addSourceType(new _source.DynamicSourceProvider()).addSourceType(new _source.CallSourceProvider()).addSourceType(new _source.StepsSourceProvider());
class SubmissionValueProvider {
  constructor(submission, providers = sourceProviders) {
    this.submission = submission;
    this.providers = providers;
  }
  setSubmission(submission) {
    this.submission = submission;
  }
  get dumbapp() {
    var _this$submission;
    return (_this$submission = this.submission) === null || _this$submission === void 0 ? void 0 : _this$submission.dumbapp;
  }
  getAccount() {
    var _this$submission2, _this$submission2$dat;
    return (_this$submission2 = this.submission) === null || _this$submission2 === void 0 ? void 0 : (_this$submission2$dat = _this$submission2.data) === null || _this$submission2$dat === void 0 ? void 0 : _this$submission2$dat.from;
  }
  getArgValue(arg, step, argNum) {
    if (this.submission) {
      const submittedArgs = this.submission.data.args[step.index];
      let val;
      if (submittedArgs) {
        if (argNum !== null && argNum !== undefined) {
          val = submittedArgs.args[argNum];
        } else if (arg.value) {
          return this.getSourceValue(arg.value, arg, step);
        }
        if (val !== undefined) {
          let provider = this;
          return {
            async value() {
              let converted = await (0, _state.convertFromValue)(provider, val, arg, step);
              return converted;
            }
          };
        }
      } else if (this.submission.dumbapp && arg.value) {
        return this.getSourceValue(arg.value, arg, step);
      }
    }
    return {
      value() {
        return "";
      }
    };
  }
  getInput(name, typing) {
    if (this.submission) {
      for (let values of this.submission.data.inputs) {
        if (values.data[name] !== undefined) {
          if (values.type === "query") {
            return (0, _data.queryDataToValue)(values.data[name], typing);
          } else if (values.type === "form") {
            return (0, _data.formDataToValue)(values.data[name], typing);
          } else {
            return values.data[name];
          }
        }
      }
    }
    return undefined;
  }
  getSourceValue(source, arg, step) {
    return this.providers.valueForSource(this, source, arg, step);
  }
}
exports.SubmissionValueProvider = SubmissionValueProvider;
//# sourceMappingURL=SubmissionValueProvider.js.map